import { componentClassName } from '@/styles/ArticleTeaserDefault';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { useArticleTeaserContext } from './ArticleTeaser';

export interface ArticleTeaserGroupProps extends ComponentProps<'div'> {
  size?: ClassNameProp<'horizontal' | 'vertical'>;
  variant?: ClassNameProp<'horizontal' | 'vertical'>;
}

export const ArticleTeaserGroupComponent: Component<ArticleTeaserGroupProps> = ({
  children,
  colors,
  size,
  variant,
  ...props
}) => {
  const { theme, ...contextClassNameProps } = useArticleTeaserContext({ colors, size, variant });

  const className = componentClassName('group', contextClassNameProps, {
    defaults: { size: 'vertical', variant: 'vertical' },
    theme,
  });

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
